export default __webpack_public_path__ + "static/media/Be Merry Christmas wreath.2e08cccf.jpg";